/**
 * Eagerly captures URL parameters on module load, then strips them from the
 * address bar via history.replaceState.  Every other module should read URL
 * state through the exported getters rather than touching window.location
 * directly.
 *
 * This prevents sensitive Firebase params (oobCode, apiKey, mode, lang) from
 * lingering in the URL / browser history after they've been consumed.
 */

// ── Capture (runs once, at import time) ─────────────────────────────────────

const _initialHref: string = window.location.href;

const _params = new URLSearchParams(window.location.search);
const _redirectUrl: string | null = _params.get('redirect_url');
const _isExtension: boolean = _params.get('extension') === 'true';

// Strip query params, hash, and transient auth paths from the address bar
// immediately so the user never sees the messy callback URL.
{
  const needsClean = window.location.search || window.location.hash
    || window.location.pathname === '/auth/email-callback';
  if (needsClean) {
    window.history.replaceState({}, '', '/');
  }
}

// ── Public getters ──────────────────────────────────────────────────────────

/** The full URL the browser originally loaded (includes oobCode, etc.). */
export function getInitialHref(): string {
  return _initialHref;
}

/** The `redirect_url` query-param that was on the original URL, if any. */
export function getRedirectUrl(): string | null {
  return _redirectUrl;
}

/** Whether the original URL had `extension=true`. */
export function getIsExtension(): boolean {
  return _isExtension;
}
